import dayjs from 'dayjs';

import { DATE_FORMAT_TEMPLATE } from 'api/constants';

import { FeatureSource, FeatureType, featureType } from '../types';

const GRANTED_BY_LABELS: { [key in FeatureSource]: string } = {
  [FeatureSource.supporter]: 'Support',
  [FeatureSource.developer]: 'Developer',
  [FeatureSource.paymentFlow]: 'Purchase',
  [FeatureSource.refundFlow]: 'Refund',
  [FeatureSource.chargebackFlow]: 'Chargeback',
  [FeatureSource.renewFlow]: 'Subscription renewal',
  [FeatureSource.cancelationFlow]: 'Cancellation',
  [FeatureSource.merchant]: 'Merchant',
  [FeatureSource.promoCodeRedeemFlow]: 'Promo code',
};

export const Feature = ({ feature }: { feature: featureType }) => {
  const getStatus = () => {
    let status = '';
    const now = Date.now();

    if (feature.type == FeatureType.consumable) {
      // Consumable
      status = feature.quantity ? 'Active' : 'Inactive';
    } else if (feature.actualFrom && feature.actualTill) {
      // Limited time case actualFrom < now < actualTill
      const actualFrom = new Date(feature.actualFrom).getTime();
      const actualTill = new Date(feature.actualTill).getTime();
      status = now > actualFrom && now < actualTill ? 'Active' : 'Inactive';
    } else if (feature.actualFrom) {
      // Lifetime case actualFrom < now
      const actualFrom = new Date(feature.actualFrom).getTime();
      status = now > actualFrom ? 'Active' : 'Inactive';
    }
    return status;
  };

  const getFeatureGrantedUntil = () => {
    const status = getStatus();

    if (status === 'Inactive') {
      return 'N/A';
    }
    return feature.actualTill
      ? dayjs(feature.actualTill).format(DATE_FORMAT_TEMPLATE)
      : 'LifeTime';
  };

  const getGrantedBy = () => {
    if (feature.grantedBy === FeatureSource.promoCodeRedeemFlow) {
      const promoCode = feature.promoCodeInfo;

      if (!promoCode) {
        return 'Promo code';
      }

      return promoCode.campaignName
        ? `Promo code ${promoCode.code} (${promoCode.campaignName})`
        : `Promo code ${promoCode.code}`;
    }

    return feature.grantedBy ? GRANTED_BY_LABELS[feature.grantedBy] : null;
  };

  const grantedBy = getGrantedBy();

  const featureRegistry: { [key: string]: string } = {
    'Feature Type:': feature.type,
    'Feature status:': getStatus(),
    'Feature is granted until:': getFeatureGrantedUntil(),
    ...(grantedBy ? { 'Granted by:': grantedBy } : {}),
  };
  const FeatureRow = () => (
    <ul data-test-id={'e2e-feature-info'}>
      {Object.keys(featureRegistry).map((key: string) => {
        return (
          <li
            className={'p-1'}
            key={key}
            data-test-id={
              'e2e-' + key.toLowerCase().replace(':', '').split(' ').join('-')
            }
          >
            <span className={'font-semibold mr-4'}>{key}</span>
            {featureRegistry[key]}
          </li>
        );
      })}
    </ul>
  );
  return (
    <div>
      <FeatureRow />
    </div>
  );
};
